"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cacheOldEnvironmentId = cacheOldEnvironmentId;
exports.deleteCookie = deleteCookie;
exports.eventEmitter = void 0;
exports.getRootDomain = getRootDomain;
exports.getSyncState = getSyncState;
exports.parsePulseCookies = parsePulseCookies;
exports.readCookie = readCookie;
exports.serializePulseCookie = serializePulseCookie;
exports.writeCookie = writeCookie;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _utils = require("./utils");
var _eventEmitter = _interopRequireDefault(require("./eventEmitter"));
var _cookieConfig = require("./cookie-config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-env browser */
var PULSE_COOKIE_KEY = _cookieConfig.cookieConfig.PULSE_COOKIE_KEY,
  TEST_COOKIE_KEY = _cookieConfig.cookieConfig.TEST_COOKIE_KEY,
  ENV_COOKIE_KEY = _cookieConfig.cookieConfig.ENV_COOKIE_KEY,
  USE_SECURE_COOKIES = _cookieConfig.cookieConfig.USE_SECURE_COOKIES;
var CIS_POLL_INTERVAL = 900000; // 15 minutes

/**
 * @private
 */
function getExpiryDate() {
  var expiresInDays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var expireTimestamp = Date.now() + expiresInDays * 1000 * 60 * 60 * 24;
  return new Date(expireTimestamp);
}

/**
 * @private
 *
 * Used by unit tests
 */
/* eslint function-paren-newline: 0 */
/* eslint max-len: [2, 130] */
function readCookie(key) {
  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*".concat(encodeURIComponent(key).replace(/[-.+*]/g, '\\$&'), "\\s*\\=\\s*([^;]*).*$)|^.*$")), '$1'));
}

/**
 * Responsible for subscribing to, and emitting events.
 */
var eventEmitter = exports.eventEmitter = new _eventEmitter["default"]();

/**
 * @private
 *
 * Used by unit tests
 */
function writeCookie(key, value, domain) {
  var expiresInDays = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var expires = getExpiryDate(expiresInDays).toUTCString();
  var cookieString = '';
  cookieString = "".concat(key, "=").concat(encodeURIComponent(value));
  cookieString += ';path=/';
  if (domain) {
    cookieString += ";domain=".concat(domain);
  }
  if (expiresInDays) {
    cookieString += ";expires=".concat(expires);
  }
  if (USE_SECURE_COOKIES && window.location.protocol === 'https:') {
    cookieString += ';SameSite=None;Secure';
  }
  document.cookie = cookieString;
}

/**
 * @private
 *
 * Used in unit tests, otherwise private
 */
function deleteCookie(key, domain) {
  writeCookie(key, '', domain, -1);
}

/* eslint no-empty: 0 */
function getRootDomain() {
  var parts = "".concat(window.location.hostname).split('.');
  var testValue = (0, _utils.randomString)();
  var domain = window.location.hostname;
  var test = '';
  for (var i = 0; i < parts.length; i += 1) {
    try {
      domain = parts.slice(-(i + 1)).join('.');
      writeCookie(TEST_COOKIE_KEY, testValue, domain, 1);
      test = readCookie(TEST_COOKIE_KEY);
      deleteCookie(TEST_COOKIE_KEY, domain);
      if (test === testValue) {
        break;
      }
    } catch (e) {}
  }
  return domain;
}
function cacheOldEnvironmentId(id) {
  try {
    var envCookie = '';
    var oldIds = {};
    try {
      envCookie = readCookie(ENV_COOKIE_KEY);
    } catch (e) {}
    try {
      oldIds = envCookie ? JSON.parse(envCookie) : [];
    } catch (e) {}
    oldIds[id] = Date.now();
    var idsToCache = Object.keys(oldIds).map(function (envId) {
      return {
        id: envId,
        date: oldIds[envId]
      };
    }).sort(function (o) {
      return o.date;
    }).slice(0, 5).reduce(function (accl, o) {
      return (0, _merge2["default"])(accl, _defineProperty({}, o.id, o.date));
    }, {});
    writeCookie(ENV_COOKIE_KEY, JSON.stringify(idsToCache), getRootDomain(), 365);
  } catch (e) {}
}
function parsePulseCookies() {
  var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : readCookie(PULSE_COOKIE_KEY);
  if (!(0, _isString["default"])(cookie)) {
    throw new Error('This method expects a cookie *string*');
  }
  var values = (0, _isString["default"])(cookie) ? decodeURIComponent(cookie).split(',') : [];
  // Cookie is in a unknown, possibly old format. Will be ignored.
  if (values.length !== 10) {
    values = [];
  }
  var altEnvCookie = readCookie(ENV_COOKIE_KEY);
  var altEnvIds;
  if (altEnvIds) {
    try {
      altEnvIds = JSON.parse(altEnvCookie);
    } catch (e) {
      altEnvIds = undefined;
    }
  }
  return {
    environmentId: values[0],
    prevUserId: values[2] ? values[2] : undefined,
    validateAfter: values[3] ? parseInt(values[3], 10) : undefined,
    jwe: values[4],
    anId: values[5],
    syncWithAppNexus: undefined,
    doTracking: values[7] ? values[7] === 'true' : undefined,
    pixelInjected: values[8] ? values[8] === 'true' : undefined,
    adId: values[9],
    altEnvIds: altEnvIds,
    visitorIdPlaceholder: values[1]
  };
}
function serializePulseCookie(input) {
  if ((0, _isString["default"])(input)) {
    throw new Error('This method expects a parsed cookie object, not a string');
  }
  var _ref = input || {},
    _ref$environmentId = _ref.environmentId,
    environmentId = _ref$environmentId === void 0 ? '' : _ref$environmentId,
    _ref$prevUserId = _ref.prevUserId,
    prevUserId = _ref$prevUserId === void 0 ? '' : _ref$prevUserId,
    _ref$jwe = _ref.jwe,
    jwe = _ref$jwe === void 0 ? '' : _ref$jwe,
    _ref$anId = _ref.anId,
    anId = _ref$anId === void 0 ? '' : _ref$anId,
    _ref$doTracking = _ref.doTracking,
    doTracking = _ref$doTracking === void 0 ? '' : _ref$doTracking,
    _ref$pixelInjected = _ref.pixelInjected,
    pixelInjected = _ref$pixelInjected === void 0 ? '' : _ref$pixelInjected,
    _ref$adId = _ref.adId,
    adId = _ref$adId === void 0 ? '' : _ref$adId,
    _ref$visitorIdPlaceho = _ref.visitorIdPlaceholder,
    visitorIdPlaceholder = _ref$visitorIdPlaceho === void 0 ? 'v' : _ref$visitorIdPlaceho;
  var now = Date.now();
  var cookieString = [environmentId, visitorIdPlaceholder, prevUserId, new Date().setTime(now + CIS_POLL_INTERVAL), jwe, anId, undefined, doTracking, pixelInjected, adId].join(',');
  writeCookie(PULSE_COOKIE_KEY, cookieString, getRootDomain(), 2 * 365);
  eventEmitter.emit('environmentIdSet', environmentId);
  eventEmitter.emit('jweSet', jwe);
}
function getSyncState(userId) {
  var cookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : readCookie(PULSE_COOKIE_KEY);
  var parsedCookie = parsePulseCookies(cookie);
  var dateNow = Date.now();
  var state = {};
  if (!cookie || cookie.indexOf('undefined') !== -1 || !parsedCookie.environmentId || !parsedCookie.jwe) {
    state.syncWithCis = true;
    state.waitForCis = true;
  } else if (String(userId) !== String(parsedCookie.prevUserId)) {
    state.syncWithCis = true;
    // Blocking call on login/new user to get opt out status, non blocking call
    // on logout to the a new JWE
    state.waitForCis = Boolean(userId);
  } else if (parsedCookie.validateAfter && dateNow > parsedCookie.validateAfter) {
    state.syncWithCis = true;
  }
  return state;
}